import { render, staticRenderFns } from "./FinalPage.vue?vue&type=template&id=53060794&"
import script from "./FinalPage.vue?vue&type=script&lang=ts&"
export * from "./FinalPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports